import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { Card, CardActionsButtons } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { Dialog, DialogProps } from 'shared/mui/Dialogs/Dialog/Dialog';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { truncateString } from 'utils/truncateString';

type Props = {
  commissionName: string;
  onAgreement: () => void;
} & DialogProps;

export const CommissionsCreateSuccessDialog: React.FC<Props> = ({
  commissionName,
  onAgreement,
  ...restProps
}) => {
  const translate = useTypedTranslate();

  return (
    <Dialog {...restProps} fullWidth width="640px">
      <Card>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={restProps.onClose} />]}
          title={translate('app.merchantCommissions.feeCreateSuccessDialog.title')}
          titleSize="smallBold"
        />
        <CardContent>
          <Typography>
            {translate('app.merchantCommissions.feeCreateSuccessDialog.newFee')}{' '}
            <Typography component="span" fontWeight={500}>
              {truncateString(commissionName, 30)}
            </Typography>{' '}
            {translate('app.merchantCommissions.feeCreateSuccessDialog.created')}
          </Typography>
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton
              key="back-button"
              label={translate('app.merchantCommissions.backToList')}
              onClick={restProps.onClose}
              variant="outlined"
            />,
            <Button
              color="primary"
              key="btn-agreement"
              label={translate('app.merchantCommissions.view')}
              onClick={onAgreement}
              variant="contained"
            />,
          ]}
        />
      </Card>
    </Dialog>
  );
};
